import encUTF8 from 'crypto-js/enc-utf8';
import encBase64 from 'crypto-js/enc-base64';

export const base64 = (
	str: string,
	prefix = 'orca://'
) => encBase64.stringify(encUTF8.parse(prefix + encBase64.stringify(encUTF8.parse(str))));

export {default as md5} from 'crypto-js/md5';
